import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalIndustry from "@/pages/ClinicalIndustry";

export const Route = createFileRoute("/en/services/clinical-solutions/ivd-clinical-performance-studies")({
  head: () => buildRouteHead("/en/services/clinical-solutions/ivd-clinical-performance-studies", {
      title: "IVD Clinical Performance Studies — Clinical Solutions | QbD Group",
      description: "Design and run IVD clinical performance studies that meet IVDR evidence requirements, from protocol and site selection to data analysis and reporting.",
    }),
  component: ClinicalIndustry,
});

